module.exports = __webpack_public_path__ + "static/media/2. Cilindro 1, Resina cristal y acrílico, 65 x 45 x 8 cm, 2020 copy.a4efab69.png";